import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from '../locales/zh.js';
import en from '../locales/en.js';

Vue.use(VueI18n);

// 从localStorage获取保存的语言，如果没有则默认为中文
const savedLocale = localStorage.getItem('locale') || 'zh';

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    zh,
    en
  }
});

export default i18n; 